import gsap from 'gsap'

import { getScrollTriggerOptions } from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const contactRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const columns = selector('[data-motion-column]')

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  if (columns) {
    timeline.fromTo(
      columns,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power2.out',
        stagger: {
          amount: 0.24
        }
      },
      0
    )
  }

  return () => {
    timeline.kill()
  }
}
